<template>
    <div>
        <div
            v-for="(option, index) in options"
            :key="index"
            class="custom-control custom-radio"
        >
            <input
                :id="'customRadio' + index.toString()"
                v-model="data"
                type="radio"
                class="custom-control-input"
                :name="name"
                :value="option.value"
                @change="onChange()"
            />
            <label class="custom-control-label" :for="'customRadio' + index">
                {{ option.label }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Radio',
    props: {
        options: Array,
        name: String,
        selected: String,
    },
    data: () => ({
        data: '',
    }),
    methods: {
        onChange() {
            this.$emit('input', this.data);
        },
    },
    mounted() {
        this.data = this.selected;
    },
};
</script>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
}
</style>
